import { z } from 'zod';

/** Permisivo a proposito: un parseo fallido revierte la clave entera a defaults (`ui-config.validator.ts`). */
export const TitlesDisplaySchema = z.object({
  enabled: z.boolean().default(true),
});
